/**
 * SalesMailer
 * SalesMailer
 *
 * OpenAPI spec version: n/a
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/';

import { BrandWithDocumentsList } from '../model/brandWithDocumentsList';
import { CurrentUserBrandsList } from '../model/currentUserBrandsList';
import { Mailing } from '../model/mailing';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MailingService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Lista marek przypisanych do zalogowanego użytkownika
     *  - __Type__: doctrine - __PageSize__: 25 - __Entity__: SalesMailer\\Domain\\Brand - __OperationId__: AccountBrandsListQuery - __OperationName__: ListQuery - __OutputModelName__: CurrentUserBrandsListItem - __ListModelName__: CurrentUserBrandsList - __DefaultSortOrder__:  - __Name__:  - __Path__: /mailing/brands/current-user-brands - __Method__: GET - __Description__:  - __Summary__: Lista marek przypisanych do zalogowanego użytkownika - __RouteName__: GETCurrentUserBrandsListItemListQuery - __Hash__: fb9ea2728cc21f78f3f2ca97852cca2f - __Input__:  - __Output__: SalesMailer\\Domain\\Brand - __InputGroups__:  - __OutputGroups__: salesBrandList - __InputModelName__:  - __OutputType__:  - __OutputFileType__:  
     * @param sortOrder Pole według którego nastąpi sortowanie
     * @param sortDirection Kierunek sortowania
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public accountBrandsListQuery(sortOrder?: string, sortDirection?: 'ASC' | 'DESC', observe?: 'body', reportProgress?: boolean): Observable<CurrentUserBrandsList>;
    public accountBrandsListQuery(sortOrder?: string, sortDirection?: 'ASC' | 'DESC', observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CurrentUserBrandsList>>;
    public accountBrandsListQuery(sortOrder?: string, sortDirection?: 'ASC' | 'DESC', observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CurrentUserBrandsList>>;
    public accountBrandsListQuery(sortOrder?: string, sortDirection?: 'ASC' | 'DESC', observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (sortOrder !== undefined && sortOrder !== null) {
            queryParameters = queryParameters.set('sortOrder', <any>sortOrder);
        }
        if (sortDirection !== undefined && sortDirection !== null) {
            queryParameters = queryParameters.set('sortDirection', <any>sortDirection);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<CurrentUserBrandsList>(`${this.basePath}/api/mailing/brands/current-user-brands`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     *  - __Type__: doctrine - __PageSize__: 25 - __Entity__: SalesMailer\\Domain\\Brand - __OperationId__: BrandsWithDocumentsListQuery - __OperationName__: ListQuery - __OutputModelName__: BrandWithDocumentsListItem - __ListModelName__: BrandWithDocumentsList - __DefaultSortOrder__:  - __Name__:  - __Path__: /mailing/brands - __Method__: GET - __Description__:  - __Summary__:  - __RouteName__: GETBrandWithDocumentsListItemListQuery - __Hash__: a63c533e26bc915e82a6f01348d527b8 - __Input__:  - __Output__: SalesMailer\\Domain\\Brand - __InputGroups__:  - __OutputGroups__: list-with-documents - __InputModelName__:  - __OutputType__:  - __OutputFileType__:  
     * @param sortOrder Pole według którego nastąpi sortowanie
     * @param sortDirection Kierunek sortowania
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public brandsWithDocumentsListQuery(sortOrder?: string, sortDirection?: 'ASC' | 'DESC', observe?: 'body', reportProgress?: boolean): Observable<BrandWithDocumentsList>;
    public brandsWithDocumentsListQuery(sortOrder?: string, sortDirection?: 'ASC' | 'DESC', observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BrandWithDocumentsList>>;
    public brandsWithDocumentsListQuery(sortOrder?: string, sortDirection?: 'ASC' | 'DESC', observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BrandWithDocumentsList>>;
    public brandsWithDocumentsListQuery(sortOrder?: string, sortDirection?: 'ASC' | 'DESC', observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (sortOrder !== undefined && sortOrder !== null) {
            queryParameters = queryParameters.set('sortOrder', <any>sortOrder);
        }
        if (sortDirection !== undefined && sortDirection !== null) {
            queryParameters = queryParameters.set('sortDirection', <any>sortDirection);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BrandWithDocumentsList>(`${this.basePath}/api/mailing/brands`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Wysyłka mailingu
     *  - __OperationName__: Handler - __OperationId__: MailingHandler - __Name__:  - __Path__: /mailing - __Method__: POST - __Description__:  - __Summary__: Wysyłka mailingu - __RouteName__: POSTHandler - __Hash__: b5ce02afc2242b477944129f9d5ecde2 - __Input__: SalesMailer\\Domain\\Mailing - __Output__:  - __InputGroups__:  - __OutputGroups__:  - __OutputModelName__:  - __InputModelName__: Mailing - __OutputType__:  - __OutputFileType__:  
     * @param content 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mailingHandler(content?: Mailing, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public mailingHandler(content?: Mailing, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public mailingHandler(content?: Mailing, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public mailingHandler(content?: Mailing, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/api/mailing`,
            content,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
